// import logo from './logo.svg';
import "./portfolio.css"
import performanceAwd from "./images/performance-bg.png"
import quarterAwd from "./images/quarter-bg.png"
import monthAwd from "./images/month-bg.png"
import myWithAwd from "./images/my-with-awd2.png"
import googleimg from "./images/skills/googleapi.png"
import awsimg from "./images/skills/aws.png"
import githubimg from "./images/skills/github.png"
import stripeimg from "./images/skills/stripe.png"
import facetecimg from "./images/skills/facetec.png"
import paypalimg from "./images/skills/paypal.png"
import redisimg from "./images/skills/redis.png"
import restapiimg from "./images/skills/restapi.png"
import socketioimg from "./images/skills/socketio.png"
import sumsubimg from "./images/skills/sumsub.png"
import twilioimg from "./images/skills/twilio.png"
import vonageimg from "./images/skills/vonage.png"
import agoraimg from "./images/skills/agora.png"
import webrtcimg from "./images/skills/webrtc.png"
import coinpaymentimg from "./images/skills/coinpayment.png"
import travelproimg from "./images/skills/travelpro.png"
import sabreimg from "./images/skills/sabre.png"
import rabbitMQ from "./images/skills/rabbitmq.webp";
import lambda from "./images/skills/awslambda.png";
import amplify from "./images/skills/amplify.png";
import firebase from "./images/skills/firebase.webp";
import OneInch from "./images/skills/1inch.webp";
import pinata from "./images/skills/pinata.webp";
import pubnub from "./images/skills/pubnub.webp";
import thirdweb from "./images/skills/thirdweb.webp";
import tradingview from "./images/skills/tradingview.webp";
import coinmarketcap from "./images/skills/coinmarketcap.png";
import binanceimg from "./images/skills/binance.png";

import openaiimg from "./images/skills/ai/chatgpt.png";
import claudeimg from "./images/skills/ai/cluade.png";
import cursorimg from "./images/skills/ai/cursorai.png";
import lovableaiimg from "./images/skills/ai/lovableai.jfif";
import githubcopilotimg from "./images/skills/ai/copilotai.png";


import { useState, useEffect } from "react"

function About({ section, setSection }) {

    const [countExperience, setCountExperience] = useState(0);

    useEffect(() => {
        const startDate = new Date("July 2019");
        const currentDate = new Date();
        const years = currentDate.getFullYear() - startDate.getFullYear();
        const months = currentDate.getMonth() - startDate.getMonth();
        const experience = years + months / 12;
        setCountExperience(experience.toFixed(1));
    }, []);

    const projectCounts = [
        {
            name: "ReactJS Projects",
            count: 12,
            icon: <i className="mdi mdi-react icon-mdi" />
        },
        {
            name: "NodeJS Projects",
            count: 20,
            icon: <i className="mdi mdi-nodejs icon-mdi" />
        },
        {
            name: "NextJS Projects",
            count: 6,
            icon: <i className="mdi mdi-react icon-mdi" />
        },
        {
            name: "TypeScript Projects",
            count: 16,
            icon: <i className="mdi mdi-language-typescript icon-mdi" />
        }
    ]

    const services = [
        {
            name: "AWS Services",
            icon: awsimg,
            description: "AWS Services"
        },
        {
            name: "Lambda",
            icon: lambda,
            description: "Lambda"
        },
        {
            name: "Amplify",
            icon: amplify,
            description: "Amplify"
        },
        {
            name: "RabbitMQ",
            icon: rabbitMQ,
            description: "RabbitMQ"
        },
        {
            name: "Redis Storage",
            icon: redisimg,
            description: "Redis Storage"
        },
        {
            name: "CoinMarketCap",
            icon: coinmarketcap,
            description: "CoinMarketCap"
        },
        {
            name: "Binance Services",
            icon: binanceimg,
            description: "Binance Services"
        },
        {
            name: "Agora Services",
            icon: agoraimg,
            description: "Agora Services"
        },
        {
            name: "WebRTC Services",
            icon: webrtcimg,
            description: "WebRTC Services"
        },
        {
            name: "Google Services",
            icon: googleimg,
            description: "Google Services"
        },
        {
            name: "Socket IO",
            icon: socketioimg,
            description: "Socket IO"
        },
        {
            name: "Firebase Console",
            icon: firebase,
            description: "Firebase Console"
        },
        {
            name: "Thirdweb",
            icon: thirdweb,
            description: "Thirdweb"
        },
        {
            name: "TradingView",
            icon: tradingview,
            description: "TradingView"
        },
        {
            name: "1Inch",
            icon: OneInch,
            description: "1Inch"
        },
        {
            name: "Pinata",
            icon: pinata,
            description: "Pinata"
        },
        {
            name: "PubNub",
            icon: pubnub,
            description: "PubNub"
        },
        {
            name: "Travelpro Services",
            icon: travelproimg,
            description: "Travelpro Services"
        },
        {
            name: "Sabre Services",
            icon: sabreimg,
            description: "Sabre Services"
        },
        {
            name: "FaceTec Services",
            icon: facetecimg,
            description: "FaceTec Services"
        },
        {
            name: "Sumsub Services",
            icon: sumsubimg,
            description: "Sumsub Services"
        },
        {
            name: "Coinpayment",
            icon: coinpaymentimg,
            description: "Coinpayment"
        },
        {
            name: "Paypal Services",
            icon: paypalimg,
            description: "Paypal Services"
        },
        {
            name: "Stripe Services",
            icon: stripeimg,
            description: "Stripe Services"
        },
        {
            name: "Twilio Services",
            icon: twilioimg,
            description: "Twilio Services"
        },
        {
            name: "Vonage",
            icon: vonageimg,
            description: "Vonage"
        }
    ]

    const aiServices = [
        {
            name: "OpenAI ChatGPT",
            icon: openaiimg,
            description: "OpenAI ChatGPT"
        },
        {
            name: "Claude AI",
            icon: claudeimg,
            description: "Claude AI"
        },
        {
            name: "Cursor AI",
            icon: cursorimg,
            description: "Cursor AI"
        },
        {
            name: "Lovable AI",
            icon: lovableaiimg,
            description: "Lovable AI"
        },
        {
            name: "Github Copilot",
            icon: githubcopilotimg,
            description: "Github Copilot"
        }
    ]

    return (
        <>
            {/* ======= About Section ======= */}
            <section id="about" className={`about ${section == "about" ? "section-show" : ""}`}>
                {/* ======= About Me ======= */}
                <div className="about-me container">
                    <div className="section-title">
                        <h2>About</h2>
                        <p>DISCOVER MORE ABOUT ME</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-4" data-aos="fade-right">
                            <img src={myWithAwd} className="img-fluid profile-image" alt="" />
                        </div>
                        <div className="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
                            <h3 className="pt-3">Sr. Full Stack Developer</h3>
                            <p className="fst-italic fst-desc15">
                                Results-driven Full Stack Developer with <span className="colorTheme">{countExperience}+ years</span> of hands-on experience designing and delivering high-performance web applications. Proven expertise in Node.js, React.js, MongoDB, and Express.js, with a strong focus on backend architecture, scalable APIs, and team leadership. Adept at managing end-to-end project lifecycles, mentoring developers, and integrating complex third-party services. Passionate about optimizing performance, security, and user experience across distributed systems.
                            </p>
                            <div className="row fst-desc14 py-3">
                                <div className="col-lg-6">
                                    <ul>
                                        <li><strong><i className="mdi mdi-phone-incoming" /></strong> <span>+91 7837802509</span></li>
                                        <li><strong><i className="mdi mdi-phone-incoming" /></strong> <span>+91 7009081075</span></li>
                                    </ul>
                                </div>
                                <div className="col-lg-6">
                                    <ul>
                                        <li><strong><i className="mdi mdi-email-variant" /></strong> <span>mukeshsingh9862@gmail.com</span></li>
                                        <li><strong><i className="mdi mdi-map-marker-radius" /></strong> <span>Chandigarh, India</span></li>
                                    </ul>
                                </div>
                            </div>

                            <div className='portfolio'>

                                <div className="row">
                                    <div className="col-lg-6 col-sm-12 portfolio-item filter-app">
                                        <div className="portfolio-wrap">
                                            <img src={quarterAwd} className="img-fluid" alt="" style={{ width: "70%" }} />
                                            <div className="portfolio-info">
                                                {/* <h4>App 1</h4> */}
                                                <p> Thank You <a href='https://blocktechbrew.com/' target='_blank'>@BlockTechBrew</a> </p>
                                                <div className="portfolio-links">
                                                    <a href={quarterAwd} target='_blank'><i className="bx bx-link" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12 portfolio-item filter-app">
                                        <div className="portfolio-wrap">
                                            <img src={monthAwd} className="img-fluid" alt="" style={{ width: "70%" }} />
                                            <div className="portfolio-info">
                                                <p> Thank You <a href='https://www.code-brew.com/' target='_blank'>@CodeBrewLabs</a> </p>
                                                <div className="portfolio-links">
                                                    <a href={monthAwd} target='_blank'><i className="bx bx-link" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>{/* End About Me */}

                {/* ======= Counts ======= */}
                <div className="counts container">
                    <div className="row">
                        {projectCounts.map((project, index) => (
                            <div className="col-lg-3 col-md-6">
                                <div className="count-box">
                                    {project.icon}
                                    <span className="purecounter">{project.count}+</span>
                                    <p>{project.name}</p>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>{/* End Counts */}

                {/* ======= Interests ======= */}

                <div className="interests container py-3">
                    <div className="section-title">
                        <h2>Boost Productivity with AI Tools </h2>
                    </div>
                    <div className="row">
                        {aiServices.map((service, index) => (
                            <div className="col-lg-3 col-md-4 mt-4 mt-md-0 my-3">
                                <div className="icon-box">
                                    <img src={service.icon} className='skill-icon' style={{ height: "34px", width: "34px" }} />
                                    <h3>{service.name}</h3>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>{/* End AI Services */}

                <div className="interests container pt-0">
                    <div className="section-title">
                        <h2>Communication Between Services</h2>
                    </div>
                    <div className="row">
                        {services.map((service, index) => (
                            <div className="col-lg-3 col-md-4 mt-4 mt-md-0 my-3">
                                <div className="icon-box">
                                    <img src={service.icon} className='skill-icon' style={{ height: "34px", width: "34px" }} />
                                    <h3>{service.name}</h3>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>{/* End Interests */}

            </section>{/* End About Section */}
        </>
    );
}

export default About;
